export const timelineEvents = [
  {
    year: 2007,
    events: [
      {
        title: "Foundation of LFNC Koramangala",
        location: "Bangalore (Koramangala)",
        description: "Started our ministry journey in Koramangala, establishing a spiritual home for the Nepali community with powerful worship and teaching.",
        icon: "🏠"
      }
    ]
  },
  {
    year: 2008,
    events: [
      {
        title: "LFNC 1st Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated our first year of ministry with thanksgiving and renewed commitment to serve the community.",
        icon: "🎉"
      },
      {
        title: "LFNC 1st Baptism - 6 Persons",
        location: "Bangalore (Koramangala)",
        description: "Witnessed the first baptism ceremony with 6 believers publicly declaring their faith in Christ.",
        icon: "💧"
      }
    ]
  },
  {
    year: 2009,
    events: [
      {
        title: "LFNC 2nd Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated two years of faithful ministry and God's blessings upon our congregation.",
        icon: "🎊"
      },
      {
        title: "First Ministry Tour to Kolhapur Maharashtra",
        location: "Kolhapur, Maharashtra",
        description: "Conducted our first ministry tour reaching out to believers in Maharashtra with the Gospel message.",
        icon: "✈️"
      }
    ]
  },
  {
    year: 2010,
    events: [
      {
        title: "LFNC 3rd Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated three years of ministry with thanksgiving and worship.",
        icon: "🎉"
      },
      {
        title: "First Branch Church in Sindhupalchowk Nepal",
        location: "Sindhupalchowk, Nepal",
        description: "Established our first branch church in Nepal, extending our ministry to our homeland.",
        icon: "🕊️"
      }
    ]
  },
  {
    year: 2011,
    events: [
      {
        title: "LFNC 4th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated four years of faithful ministry and growth.",
        icon: "🎊"
      },
      {
        title: "Worship First Album - LFNC JEEVIT VISHWAS",
        location: "Bangalore",
        description: "Released our first worship album 'LFNC Jeevit Vishwas' featuring original Nepali Christian songs.",
        icon: "🎵"
      }
    ]
  },
  {
    year: 2012,
    events: [
      {
        title: "LFNC 5th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated five years of ministry with special programs and worship.",
        icon: "🎉"
      },
      {
        title: "LFNC Ministry Tour West Bengal and Sikkim",
        location: "West Bengal & Sikkim",
        description: "Conducted ministry tours across West Bengal and Sikkim, spreading the Gospel and encouraging believers.",
        icon: "🚌"
      }
    ]
  },
  {
    year: 2013,
    events: [
      {
        title: "LFNC 6th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated six years of God's faithfulness and ministry growth.",
        icon: "🎊"
      },
      {
        title: "Branch Opening at Sanga Chowk Nepal",
        location: "Sanga Chowk, Nepal",
        description: "Opened a new branch church in Sanga Chowk, expanding our reach in Nepal.",
        icon: "🏛️"
      }
    ]
  },
  {
    year: 2014,
    events: [
      {
        title: "LFNC 7th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated seven years of ministry with thanksgiving and worship.",
        icon: "🎉"
      },
      {
        title: "Branch Church Opening at Kurseong Nepal",
        location: "Kurseong, Nepal",
        description: "Established a new branch church in Kurseong to serve the local community.",
        icon: "⛪"
      }
    ]
  },
  {
    year: 2015,
    events: [
      {
        title: "LFNC 8th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated eight years of faithful ministry and community impact.",
        icon: "🎊"
      },
      {
        title: "Branch Church Opening at Jagarkot Nepal",
        location: "Jagarkot, Nepal",
        description: "Opened a new branch church in Jagarkot, extending our ministry reach.",
        icon: "🏠"
      }
    ]
  },
  {
    year: 2016,
    events: [
      {
        title: "LFNC 9th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated nine years of ministry with special programs.",
        icon: "🎉"
      },
      {
        title: "Kathmandu Branch Church Opening",
        location: "Kathmandu, Nepal",
        description: "Established a major branch church in Kathmandu, Nepal's capital city.",
        icon: "🌟"
      }
    ]
  },
  {
    year: 2017,
    events: [
      {
        title: "LFNC 10th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated a decade of ministry with grand celebrations and thanksgiving.",
        icon: "🎊"
      },
      {
        title: "Branch Church Opening Electronic City",
        location: "Bangalore (Electronic City)",
        description: "Expanded our reach to Electronic City, serving more families with vibrant programs.",
        icon: "🚀"
      }
    ]
  },
  {
    year: 2018,
    events: [
      {
        title: "LFNC 11th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated eleven years of faithful ministry and growth.",
        icon: "🎉"
      },
      {
        title: "Branch Church Opening Nepalgunj Nepal",
        location: "Nepalgunj, Nepal",
        description: "Opened a new branch church in Nepalgunj to serve the western region of Nepal.",
        icon: "⛪"
      },
      {
        title: "Branch Church Opening Jorepati Nepal",
        location: "Jorepati, Nepal",
        description: "Established a branch church in Jorepati, expanding our ministry network.",
        icon: "🏛️"
      }
    ]
  },
  {
    year: 2019,
    events: [
      {
        title: "LFNC 12th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated twelve years of ministry with worship and thanksgiving.",
        icon: "🎊"
      },
      {
        title: "Healing and Revival in Different Parts of Nepal",
        location: "Various Locations, Nepal",
        description: "Conducted healing and revival meetings across Nepal, witnessing miraculous transformations.",
        icon: "🙏"
      }
    ]
  },
  {
    year: 2020,
    events: [
      {
        title: "LFNC 13th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated thirteen years of ministry during challenging times.",
        icon: "🎉"
      },
      {
        title: "Global Online Fellowship of LFNC",
        location: "Online Platform",
        description: "Launched global online fellowship connecting believers worldwide during the pandemic.",
        icon: "💻"
      },
      {
        title: "Pastor Prayer Tour Malaysia 2020",
        location: "Malaysia",
        description: "Pastor Roshan Rai conducted prayer tour in Malaysia ministering to the diaspora community.",
        icon: "✈️"
      },
      {
        title: "COVID Support for Believers and Non-Believers",
        location: "All Locations",
        description: "Provided essential supplies and support to affected families during the COVID-19 pandemic.",
        icon: "❤️"
      }
    ]
  },
  {
    year: 2021,
    events: [
      {
        title: "LFNC 14th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated fourteen years of faithful ministry and God's provision.",
        icon: "🎊"
      },
      {
        title: "Grand Healing Crusade at Kathmandu Nepal",
        location: "Kathmandu, Nepal",
        description: "Organized a grand healing crusade in Kathmandu with thousands in attendance witnessing God's power.",
        icon: "🔥"
      }
    ]
  },
  {
    year: 2022,
    events: [
      {
        title: "LFNC 15th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated fifteen years of ministry with special programs and worship.",
        icon: "🎉"
      },
      {
        title: "Branch Church Opening Banepa Nepal",
        location: "Banepa, Nepal",
        description: "Established a new branch church in Banepa, continuing our expansion in Nepal.",
        icon: "⛪"
      }
    ]
  },
  {
    year: 2023,
    events: [
      {
        title: "Grand LFNC 16th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated sixteen years of ministry with grand celebrations and thanksgiving to God.",
        icon: "🎊"
      }
    ]
  },
  {
    year: 2024,
    events: [
      {
        title: "LFNC 17th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrated seventeen years of faithful ministry and growth.",
        icon: "🎉"
      },
      {
        title: "Pastor Roshan Rai 25th Silver Jubilee Ministry",
        location: "Bangalore",
        description: "Celebrated Pastor Roshan Rai's 25 years of dedicated ministry with special programs and testimonies.",
        icon: "🏆"
      },
      {
        title: "Couple Seminar by Rev. Dr. Victor Moktan",
        location: "Bangalore",
        description: "Organized a transformative couple seminar led by Rev. Dr. Victor Moktan strengthening marriages.",
        icon: "💑"
      }
    ]
  },
  {
    year: 2025,
    events: [
      {
        title: "LFNC 18th Anniversary",
        location: "Bangalore (Koramangala)",
        description: "Celebrating eighteen years of ministry with worship and thanksgiving.",
        icon: "🎊"
      },
      {
        title: "Worship Workshop with Samir Diyali and Santosh Baraily",
        location: "Bangalore",
        description: "Conducted worship workshop with renowned worship leaders Samir Diyali and Santosh Baraily.",
        icon: "🎵"
      },
      {
        title: "LFNC Church Shifting to Maharaj Singal Koramangala",
        location: "Maharaj Singal, Koramangala",
        description: "Relocated to a new facility in Maharaj Singal, Koramangala for expanded ministry opportunities.",
        icon: "🏛️"
      }
    ]
  }
];
